import { authResetPasswordError, authResetPasswordSuccess } from '@store/slices/auth/authSlice.js';
import httpClient from '@utils/httpClient';
import { call, put } from 'redux-saga/effects';

function resetPasswordApiCall({ email, turnstileToken }) {
  const params = new URLSearchParams({ username: email, turnstileToken });
  return httpClient.post(`api/account/SendForgotPasswordEmail?${params.toString()}`, {});
}

export function* resetPasswordRequestSaga({ payload }) {
  try {
    const { email, turnstileToken } = payload;
    yield call(resetPasswordApiCall, { email, turnstileToken });
    yield put(authResetPasswordSuccess());
  } catch (error) {
    yield put(authResetPasswordError(error.Message ? error.Message : error.toString()));
  }
}
